import { render, staticRenderFns } from "./RequestTabsView.vue?vue&type=template&id=20dc7cb0&scoped=true&"
import script from "./RequestTabsView.vue?vue&type=script&lang=ts&"
export * from "./RequestTabsView.vue?vue&type=script&lang=ts&"
import style0 from "./RequestTabsView.vue?vue&type=style&index=0&id=20dc7cb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dc7cb0",
  null
  
)

export default component.exports